import Guid from '@/app/utils/guid'
import { Activity } from '@/stakeholders/entities/activity'
import { Attitude } from '@/stakeholders/entities/attitude'
import NodeEntity from '@/common/models/node-entitiy'

export default class ProjectStakeholder extends NodeEntity {

  public projectId = Guid.empty()
  public groupId = Guid.empty()
  public role = ''
  public region = ''
  public description = ''
  public interest = 0
  public influence = 0
  public activity = Activity.Active
  public attitude = Attitude.Neutral
  public stakeholderId = Guid.empty()
  public order = 0
}
